<template>
  <div class="avatar-wrapper text-center">
    <!-- <img :src="userProfile.PIC_URL" class="avatar" /> -->
    <avatar :src="avatarUrl" :username="fullName" :size="180" :rounded="false" class="avatar"></avatar>
    <!-- <b-img rounded blank class="avatar" blank-color="#777" alt="img" v-if="!userProfile.PIC_URL" /> -->
    <div class="card-img-overlay">
      <button class="btn btn-sm btn-outline-light" id="pick-avatar">Upload Image</button>
    </div>
    <avatar-cropper
      :labels="{submit: 'Upload', cancel: 'Cancel'}"
      @uploading="handleUploading"
      @uploaded="handleUploaded"
      @error="handlerError"
      trigger="#pick-avatar"
      upload-form-name="image"
      :upload-headers="options.headers"
      :upload-url="options.url">
    </avatar-cropper>
  </div>
</template>

<script>
import { auth } from '@/services/'
import AvatarCropper from 'vue-avatar-cropper'
import Avatar from 'vue-avatar'

export default {
  name: 'profile-avatar',
  props: ['picUrl'],
  components: { AvatarCropper, Avatar },
  data() {
    return {
      message: "ready",
      avatarUrl: this.picUrl,
      options: {
        url: `${process.env.VUE_APP_API_URL}/fileUpload/Pic_User`,
        headers: { 'authorization': auth.getToken() }
      }
    }
  },
  methods: {
    handleUploading(form, xhr) {
      this.message = "uploading...";
    },
    handleUploaded(response) {
      this.avatarUrl = response.msgContent.fileUrl
      this.$emit('avatarUploaded', response.msgContent.fileUrl)
      this.message = "user avatar updated.";
    },
    handlerError(message, type, xhr) {
      this.message = "Oops! Something went wrong...";
    }
  },
  computed: {
    fullName() {
      let user = auth.getUser()
      return `${user.USER_PROFILE_FIRST_NAME} ${user.USER_PROFILE_LAST_NAME}`
    }
  }
};
</script>
<style lang="scss" scoped>
.avatar-wrapper {
  max-width: 18em;
  margin: 0 auto;
  &:hover {
    .card-img-overlay {
      display: block;
    }
  }
}
.avatar {
  width: 180px;
  height: 180px;
  border-radius: 6px;
  display: block;
  margin: 0px auto;
}
.card-img-overlay {
  display: none;
}
.card-img-overlay button {
  margin-top: 10vh;
}
</style>
